import React from "react";

import { observer } from "mobx-react";

import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";

import { CategoryItem } from ".";

export const CategoryItems = observer(function CategoryItems(props: {
	sport: PrematchOfferMenuStore["menu"];
	store: {
		selectedSport: PrematchOfferMenuStore["selectedSport"];
	} & Parameters<typeof CategoryItem>[0]["store"];
}) {
	if (
		props.sport?.children == null ||
		(props.store.selectedSport == null && !props.sport.isExpanded)
	) {
		return null;
	}

	return (
		<ul className="nav--tertiary__menu">
			{props.sport.children.map((category) => (
				<CategoryItem
					key={category.node.id}
					sport={props.sport}
					category={category}
					store={props.store}
				/>
			))}
		</ul>
	);
});
